import { z } from 'zod';

import { CompanyType } from 'src/api';

import { FormField } from '../constants';
import type { FormValues } from '../types';

export const formValidationSchema = (
  z.object({
    [FormField.controlledBy]: z.enum(CompanyType),
    [FormField.peoPayrollProvider]: z
      .object({ id: z.string(), displayName: z.string().nullable() })
      .nullable(),
    [FormField.keepOwnRevenueShare]: z.boolean(),
  }) satisfies z.ZodType<FormValues>
).superRefine((values, ctx) => {
  if (values.controlledBy === CompanyType.PeoPayrollProvider && !values.peoPayrollProvider) {
    ctx.addIssue({
      code: 'custom',
      message: 'Required',
      path: [FormField.peoPayrollProvider],
    });
  }
});
